import React from 'react'
import ApexCharts from 'apexcharts'
import ApexCahrt from '../Grpahs/ApexChart';

const SampleOneMore = () => {
  return (
    <div>SampleOneMore
    
    
    
    
    <ApexCahrt/>
    
    </div>
  )
}

export default SampleOneMore